@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    --background: 0 0% 100%;
    --foreground: 224 71.4% 4.1%;
    --card: 0 0% 100%;
    --card-foreground: 224 71.4% 4.1%;
    --popover: 0 0% 100%;
    --popover-foreground: 224 71.4% 4.1%;
    --primary: 174.7 83.9% 31.6%;
    --primary-foreground: 210 20% 98%;
    --secondary: 220 14.3% 95.9%;
    --secondary-foreground: 220.9 39.3% 11%;
    --muted: 220 14.3% 95.9%;
    --muted-foreground: 220 8.9% 46.1%;
    --accent: 220 14.3% 95.9%;
    --accent-foreground: 220.9 39.3% 11%;
    --destructive: 0 84.2% 60.2%;
    --destructive-foreground: 210 20% 98%;
    --border: 220 13% 91%;
    --input: 220 13% 91%;
    --ring: 174.7 83.9% 31.6%;
    --radius: 0.75rem;
  }

  .dark {
    --background: 224 71.4% 4.1%;
    --foreground: 210 20% 98%;
    --card: 222.2 84% 4.9%;
    --card-foreground: 210 20% 98%;
    --popover: 222.2 84% 4.9%;
    --popover-foreground: 210 20% 98%;
    --primary: 174.7 83.9% 31.6%;
    --primary-foreground: 210 20% 98%;
    --secondary: 215 27.9% 16.9%;
    --secondary-foreground: 210 20% 98%;
    --muted: 215 27.9% 16.9%;
    --muted-foreground: 217.9 10.6% 64.9%;
    --accent: 215 27.9% 16.9%;
    --accent-foreground: 210 20% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 210 20% 98%;
    --border: 215 27.9% 16.9%;
    --input: 215 27.9% 16.9%;
    --ring: 174.7 83.9% 31.6%;
  }
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.disclaimer-content,
.disclaimer-content * {
  color: #6b7280 !important;
  line-height: 1.3 !important;
  font-size: 13.5px !important;
  text-align: center !important;
  word-wrap: break-word !important;
  white-space: pre-wrap !important;
}

.disclaimer-content a {
  text-decoration: underline !important;
  cursor: pointer !important;
}

.disclaimer-content a:hover {
  opacity: 0.8;
}

.app-shell {
  min-height: 100svh;
  box-sizing: border-box;
  padding-top: env(safe-area-inset-top, 0px);
  /* Keyboard padding is handled at component level (.chat-widget-root) */
  padding-bottom: 0;
}

.chat-widget-root {
  flex: 1;
}

html[data-react-native='true'],
body[data-react-native='true'] {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  -webkit-text-size-adjust: 100%;
  touch-action: pan-y;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: transparent;
}

/* React Native WebView optimizations */
[data-react-native='true'] {
  -webkit-overflow-scrolling: touch;
  -webkit-tap-highlight-color: transparent;
}

[data-react-native='true'] html,
[data-react-native='true'] body {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  -webkit-text-size-adjust: 100%;
  touch-action: pan-y;
}
